import { ContentfulObjAnalytics } from '../../../../types'
import { FlooringCatalogHit, FurnitureCatalogHit } from '../../../../types/algolia/catalog-index'
import { DetectSiteDomain } from '@utils/detect-site-domain'
import { isObjAnalytics } from '@utils/type-guards/is-obj-analytics'
import {
  flooringCatalogHitToProductMeasureDTO,
  furnitureCatalogHitToProductMeasureDTO,
  objAnalyticsToProductMeasureDTO,
} from '@utils/analytics/transformations/product-measure'
import { ProductMeasureEventDTO, ProductMeasureEventTypes } from '../../../../types/analytics/analytics-data'

export const createSelectItemDTO = (
  data: ContentfulObjAnalytics | FlooringCatalogHit | FurnitureCatalogHit,
  siteDomainInfo: DetectSiteDomain,
  index: number,
): ProductMeasureEventDTO => {
  const { furnitureSite } = siteDomainInfo

  // Synsisal Site - Obj Analytics
  if (isObjAnalytics(data)) {
    return objAnalyticsToProductMeasureDTO(data, index, siteDomainInfo, ProductMeasureEventTypes.SELECT_ITEM)
  }

  // Curran Home Furniture Site - FurnitureCatalogHit
  if (furnitureSite) {
    return furnitureCatalogHitToProductMeasureDTO(
      data as FurnitureCatalogHit,
      index,
      ProductMeasureEventTypes.SELECT_ITEM,
    )
  }

  // Flooring Sites - FlooringCatalogHit
  return flooringCatalogHitToProductMeasureDTO(
    data as FlooringCatalogHit,
    index,
    siteDomainInfo,
    ProductMeasureEventTypes.SELECT_ITEM,
  )
}
